module.exports = __webpack_public_path__ + "img/sdm2.ba59852b.jpg";